import React from 'react';
import Input from '../../../components/inputs/Input';
import Dropdown from '../../../components/dropdown/Dropdown';
import { OrderSort, FilterCounts } from '../Orders';
import SimpleCheckBox from '../../../components/inputs/Checkbox/SimpleCheckbox';

const WAIT_INTERVAL = 500;

interface State {
  currentSearch: string;
  currentSort: OrderSort;
}

interface Props {
  currentSearch: string;
  currentSort: OrderSort;
  onFilterChange: (string) => void;
  onlyScannedAtPartner: boolean;
  onlyUnscannedAtPartner: boolean;
  onlyUnscannedAtHub: boolean;
  largeProductFilter: boolean;
  onScannedAtPartnerFilterChange: () => void;
  onUnscannedAtPartnerFilterChange: () => void;
  onUnscannedAtHubFilterChange: () => void;
  onLargeProductFilterChange: () => void;
  onlyScannedAtHub: boolean;
  onScannedAtHubFilterChange: () => void;
  changeSortBy: (OrderSort) => void;
  labelId: string;
  filterCounts: FilterCounts;
}

export default class OrdersMenuBar extends React.Component<Props, State> {
  private timer: any;

  constructor(props) {
    super(props);

    this.state = {
      currentSearch: props.currentSearch,
      currentSort: props.currentSort,
    };
  }

  UNSAFE_componentWillMount() {
    this.timer = null;
  }

  handleChange = currentSearch => {
    clearTimeout(this.timer);

    this.setState({ currentSearch });

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.triggerChange();
    }
  };

  triggerChange = () => {
    const { currentSearch } = this.state;

    this.props.onFilterChange(currentSearch);
  };

  updateAndChangeSortBy = value => {
    let sortEnum = OrderSort.Delivery;
    if (value === OrderSort.Created) {
      sortEnum = OrderSort.Created;
    }
    this.setState({ currentSort: sortEnum });
    this.props.changeSortBy(sortEnum);
  };

  render() {
    const { totalCount, partnerScanCount, hubScanCount, largeProductCount } =
      this.props.filterCounts;
    return (
      <div className="menuBarRight">
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Input
            style={{
              display: 'inline',
              width: '100%',
              minWidth: '150px',
              borderRadius: 5,
              fontSize: '1.5rem',
              paddingTop: 8,
              paddingBottom: 8,
              height: '40px',
            }}
            placeholder="Search..."
            onChange={event => this.handleChange(event.target.value)}
            onKeyPress={this.handleKeyPress}
            value={this.state.currentSearch}
          />
          &nbsp;
          <Dropdown
            names={['Sort by delivery', 'Sort by created']}
            values={[OrderSort.Delivery, OrderSort.Created]}
            placeholder={`Sorted by: ${this.state.currentSort}`}
            onChange={value => this.updateAndChangeSortBy(value)}
            customStyle={{
              height: '40px',
              width: '140px',
              padding: '7px 2px 7px 2px',
            }}
          />
        </div>
        <div style={{ marginTop: '5px' }}>
          <SimpleCheckBox
            onChange={this.props.onLargeProductFilterChange}
            selected={this.props.largeProductFilter}
            label={`(${largeProductCount}) large orders`}
            labelId={`${this.props.labelId}-product-type-large`}
          />
          <SimpleCheckBox
            onChange={this.props.onScannedAtPartnerFilterChange}
            selected={this.props.onlyScannedAtPartner}
            label={`(${partnerScanCount}) partner scan`}
            labelId={`${this.props.labelId}-with-partner-scan`}
          />
          <SimpleCheckBox
            onChange={this.props.onUnscannedAtPartnerFilterChange}
            selected={this.props.onlyUnscannedAtPartner}
            label={`(${totalCount - partnerScanCount}) w/o partner scan`}
            labelId={`${this.props.labelId}-without-partner-scan`}
          />
          <SimpleCheckBox
            onChange={this.props.onScannedAtHubFilterChange}
            selected={this.props.onlyScannedAtHub}
            label={`(${hubScanCount}) hub scan`}
            labelId={`${this.props.labelId}-with-hub-scan`}
          />
          <SimpleCheckBox
            onChange={this.props.onUnscannedAtHubFilterChange}
            selected={this.props.onlyUnscannedAtHub}
            label={`(${totalCount - hubScanCount}) w/o hub scan`}
            labelId={`${this.props.labelId}-hub-scan`}
          />
        </div>
      </div>
    );
  }
}
